import i18n from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { getShipmentProductClassEffect } from '../../../redux/shipment/ShipmentEffects';
import { routeFileSelector } from '../../../utilz/i18n';
import FormSelectBox from '../Inputs/FormSelectBox';

const ShipmentProductClassSelector = ({
  placeholder = i18n.t('translation:default.fields.locationType.placeholder'),
  label = i18n.t('translation:default.fields.locationType.label'),
  rules = [],
  name,
  editMode,
  onChange = false,
  margin = 'mb-0',
  tooltip,
  isDefault = false,
  tabIndex,
  dataTestId,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  useEffect(() => {
    getStatusList();
  }, []);

  const getStatusList = async () => {
    const nonHazardous = { label: 'Non Hazardous', value: 'N/A' };

    try {
      setLoading(true);
      const { data } = await getShipmentProductClassEffect();
      const options = data.map((row) => ({
        label: row.codeDesc,
        value: row.codeId,
      }));
      setOptions([nonHazardous, ...options]);
      setLoading(false);
    } catch {
      setOptions([nonHazardous]);
      setLoading(false);
    }
  };

  return (
    <FormSelectBox
      loading={loading}
      options={
        isDefault === true ? [{ label: t('translation:default.buttons.select'), value: '' }, ...options] : options
      }
      placeholder={placeholder}
      label={label}
      margin={margin}
      rules={rules}
      name={name}
      editMode={editMode}
      tooltip={tooltip}
      {...(onChange ? { onChange } : {})}
      tabIndex={tabIndex}
      dataTestId={dataTestId}
    />
  );
};

export default ShipmentProductClassSelector;
